export const BUILD_ID = 'toast-bottom-20261105'
export const APP_ENV = 'PROD'
